import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { TRASH_ICON } from "common/constants"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useTranslation } from "react-i18next"

export const ModalEliminarCuenta = ({
  isOpen = false,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean
  onConfirm?: () => void
  onCancel?: () => void
}) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-100 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Actions'
          className='tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-4'
        >
          <ButtonERP
            customize={{
              type: "white",
              size: "md",
            }}
            onClick={onCancel}
            label={`${t("bancos.table.modal.cancelButton")}`}
          />
          <ButtonERP
            onClick={onConfirm}
            customize={{
              type: "danger",
              size: "md",
            }}
            label={`${t("bancos.modal.confirmButton")}`}
          />
        </div>
      }
    >
      <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center  tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-6'>
        <img
          src={TRASH_ICON}
          alt='Imagen papelera de reciclaje'
        />
      </div>
      <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
        {t("bancos.modal.deleteTitle")}
      </div>
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-text-center tw-px-4'>
        <p className='tw-mb-6'>{t("bancos.modal.msgModal")}</p>
      </div>
    </PrimeReactModal>
  )
}
